const menu = document.querySelector(".menu");
const menuBtn = document.getElementById("mobile-menu-btn");
const mainNav = document.getElementById("nav-main");
const topBanner = document.querySelector(".top-banner");
const overlay = document.querySelector(".overlay");
const topLevelNavLink = document.querySelectorAll(".has-sub > a");
const siteHeader = document.querySelector("header");

function setMenuTop() {
    if (siteHeader && window.innerWidth < 1440) {
        menu.style.top = siteHeader.offsetHeight + "px";
    }
}

function toggleMenu() {
    menu.classList.toggle("open");
    this.classList.toggle("open");
    mainNav.classList.toggle("open");
    overlay.classList.toggle("open");

    if (topBanner) {
        topBanner.classList.toggle("hide");
    }
}

function closeMenu() {
    mainNav.classList.remove("open");
    menu.classList.remove("open");
    menuBtn.classList.remove("open");
    overlay.classList.remove("open");

    if (topBanner) {
        topBanner.classList.remove("hide");
    }
}

document.addEventListener("keyup", function(e) {
    if (e.key === "Escape") closeMenu();
});


menuBtn.addEventListener("click", toggleMenu);
overlay.addEventListener("click", closeMenu);
topLevelNavLink.forEach(link => {
    link.addEventListener("click", (e) => {
        if (!link.href.includes("/healthcare-staffing-trends")) e.preventDefault();
    });
});

setMenuTop();
window.addEventListener("resize", setMenuTop);

// Always fire closeMenu() at 1440px breakpoint
const mq = window.matchMedia("screen and (min-width: 1440px)");

mq.addEventListener("change", event => {
    if (event.matches) {
        closeMenu();
    }
})
